import React from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, EffectFade } from "swiper/modules";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-fade";

import Banner from "../../../assets/image/banner.jpg";
import Banner1 from "../../../assets/image/banner-1.jpg";
import Banner2 from "../../../assets/image/banner-2.jpg";

const slides = [
  {
    img: Banner,
    smallText: "Seamless assistance & coordination",
    title: "Your trusted partner in document management and visa processing- delivering precision, transparency, and total confidence at every step.",
    btn: "Discover Solutions",
  },
  {
    img: Banner1,
    smallText: "Global Reach, Personal Guidance",
    title: "Your journey begins with expert guidance.",
    btn: "Explore Options",
  },
  {
    img: Banner2,
    smallText: "Trusted by thousands",
    title: "Join countless successful applicants who moved with clarity and ease. Your success is our priority.",
    btn: "Get Started",
  },
];

const Hero = () => {
  return (
    <div className="relative w-full overflow-hidden h-[80vh] sm:h-[90vh] md:h-screen">

      {/* LEFT ARROW */}
      <div className="
        swiper-button-prev
        bg-black/40 p-2 sm:p-3
        rounded-full shadow-lg
        hover:bg-black/60 transition
        left-3 sm:left-6
      ">
        <MdKeyboardArrowLeft className="text-white text-xl sm:text-3xl" />
      </div>

      {/* RIGHT ARROW */}
      <div className="
        swiper-button-next
        bg-black/40 p-2 sm:p-3
        rounded-full shadow-lg
        hover:bg-black/60 transition
        right-3 sm:right-6
      ">
        <MdKeyboardArrowRight className="text-white text-xl sm:text-3xl" />
      </div>

      <Swiper
        modules={[Navigation, Autoplay, EffectFade]}
        navigation={{
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        effect="fade"
        loop
        className="w-full h-full"
      >
        {slides.map((item, i) => (
          <SwiperSlide
            key={i}
            className="group relative w-full h-[80vh] sm:h-[90vh] md:h-screen"
          >
            {/* IMAGE (SLOW ZOOM) */}
            <img
              src={item.img}
              alt="slider"
              className="
                w-full h-full object-cover
                scale-100
                transition-transform duration-[6000ms] ease-linear
                group-[.swiper-slide-active]:scale-110
              "
            />

            {/* OVERLAY */}
            <div className="absolute inset-0 bg-black/50"></div>

            {/* TEXT */}
            <div
              className="
                absolute
                left-4 right-4
                sm:left-10 sm:right-10
               md:left-32 md:right-auto md:w-[80%]
                top-1/3 -translate-y-2/2
                text-white
                md:w-[80%]
                opacity-0 translate-y-20
                transition-all duration-1000 ease-out
                group-[.swiper-slide-active]:opacity-100
                group-[.swiper-slide-active]:translate-y-0
              "
            >
              <h4 className="text-sm sm:text-base md:text-lg border-b border-white inline-block mb-4 uppercase tracking-wide">
                {item.smallText}
              </h4>

              <h1 className="text-2xl sm:text-4xl md:text-5xl font-bold leading-tight mb-6">
                {item.title}
              </h1>
              <div className="flex gap-2 mb-6">
                <div className="w-12 h-[3px] bg-white"></div>
                <div className="w-1 h-[3px] bg-white"></div>
                <div className="w-1 h-[3px] bg-white"></div>
                <div className="w-1 h-[3px] bg-white"></div>
              </div>
              <Link
                to="#"
                className="
                  inline-block px-5 py-3
                  text-sm sm:text-base md:text-lg
                  border-2 border-white
                  hover:bg-white hover:text-black
                  transition
                "
              >
                {item.btn}
              </Link>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Hero;
